import { Card, CardHeader, StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { BpM } from '../../shared/brakepoints';
import FintechOneAddress from '../../components/FintechOneAddress';
import Translator from '../../components/Translator';
import { LanguageEntries } from '../../shared/language/LanguageEntries';

type CssClasses = 'cardContent' | 'container';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  container: {
    width: '100%',
    [BpM()]: {
      width: '800px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardContent: {
    fontSize: '17px',
    fontFamily: 'Lato, Helvetica, Arial, Lucida, sans-serif',
    color: '#666',
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
  },
});

interface Props {
  headerTitleLanguageEntry: keyof LanguageEntries
  successTextLanguageEntry: keyof LanguageEntries
}

const SuccessPage = ({ classes, headerTitleLanguageEntry, successTextLanguageEntry }: Props & WithStyles<CssClasses>) => (
  <Translator>
    {translate => {
      return (
        <Card className={classes.container}>
          <CardHeader title={translate(headerTitleLanguageEntry)} />
          <div className={classes.cardContent}>
            <div dangerouslySetInnerHTML={{__html: translate(successTextLanguageEntry)}}/>
            <FintechOneAddress />
          </div>
        </Card>
      );
    }}
  </Translator>
);

export default pure(withStyles(styles)(SuccessPage));



// WEBPACK FOOTER //
// ./src/routes/responsePage/SuccessPage.tsx